import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_EMAIL_TEMPLATES = "GET_EMAIL_TEMPLATES";

export interface GetEmailTemplatesAction extends Action {
  type: typeof GET_EMAIL_TEMPLATES;
  organization: OrganizationKeyName;
}

export const getEmailTemplatesAction = (
  organization: OrganizationKeyName
): GetEmailTemplatesAction => ({
  type: GET_EMAIL_TEMPLATES,
  organization,
});
